import React, { useEffect, useRef } from "react";
import cookie1 from '../assets/images/cookie1.png';
import cookie2 from '../assets/images/cookie2.png';
import cookie3 from '../assets/images/cookie3.png';

const CookiesBouncing = () => {
  const containerRef = useRef(null);
  const cookieRefs = useRef([]);
  const animationFrameId = useRef(null); // Almacena el ID del requestAnimationFrame
  const numberOfCookies = 250;

  useEffect(() => {
    const cookies = cookieRefs.current;
    const velocities = cookies.map(() => ({
      x: Math.random() * 2 - 1, // Velocidad aleatoria en X (-1 a 1)
      y: Math.random() * 2 - 1, // Velocidad aleatoria en Y (-1 a 1)
    }));

    const moveCookies = () => {
      if (!containerRef.current) return; // Si el contenedor no existe, salimos
      cookies.forEach((cookie, i) => {
        if (!cookie) return; // Verifica que la galleta exista
        const rect = cookie.getBoundingClientRect();
        const containerRect = containerRef.current.getBoundingClientRect();

        // Cambiar dirección si toca los bordes
        if (rect.left <= containerRect.left || rect.right >= containerRect.right) {
          velocities[i].x *= -1; // Invertir dirección en X
        }
        if (rect.top <= containerRect.top || rect.bottom >= containerRect.bottom) {
          velocities[i].y *= -1; // Invertir dirección en Y
        }

        // Actualizar posición
        const currentTransform = getComputedStyle(cookie).transform.match(/matrix.*\((.+)\)/);
        const [currentX, currentY] = currentTransform
          ? currentTransform[1].split(", ").slice(4, 6).map(parseFloat)
          : [0, 0];

        cookie.style.transform = `translate(${currentX + velocities[i].x * 2}px, ${
          currentY + velocities[i].y * 2
        }px)`;
      });

      animationFrameId.current = requestAnimationFrame(moveCookies); // Continuar la animación
    };

    animationFrameId.current = requestAnimationFrame(moveCookies);

    return () => {
      cancelAnimationFrame(animationFrameId.current); // Limpia el bucle de animación al desmontar
    };
  }, []);

/*  const cookieBaseStyles = {
    position: "absolute",
    width: "50px",
    height: "50px",
    backgroundColor: "#d9a066", // Color de galleta
    borderRadius: "50%",
    boxShadow: "inset 0px 0px 5px #b17643, 0px 0px 10px #f4cba5", // Sombras
  };*/

  const cookieImages = [cookie1, cookie2, cookie3];

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        overflow: "hidden",
        zIndex:10000
      }}
    >
      {Array.from({ length: numberOfCookies }).map((_, index) => (
        /*<div
          key={index}
          ref={(el) => (cookieRefs.current[index] = el)}
          style={{
            ...cookieBaseStyles,
            transform: `translate(${Math.random() * window.innerWidth}px, ${
              Math.random() * window.innerHeight
            }px)`,
          }}
        />*/
        <img
          key={index}
          ref={(el) => (cookieRefs.current[index] = el)}
          src={cookieImages[Math.floor(Math.random() * cookieImages.length)]} // Ruta de la imagen
          alt="Cookie"
          style={{
            position: "absolute",
            width: "50px",
            height: "50px",
            transform: `translate(${Math.random() * window.innerWidth}px, ${
              Math.random() * window.innerHeight
            }px)`,
          }}
        />
      ))}
    </div>
  );
};

export default CookiesBouncing;
